export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    typeLabels: {
      'fixed_amount': 'Valor fixo',
      'percent': 'Porcentagem'
    },
    fields: [
      {
        key: 'code',
        label: 'Código'
      },
      {
        key: 'type',
        label: 'Tipo'
      },
      {
        key: 'amount',
        label: 'Valor'
      },
      {
        key: 'validFrom',
        label: 'Válido a partir de'
      },
      {
        key: 'validUntil',
        label: 'Válido até'
      },
      {
        key: 'totalUses',
        label: 'Total de usos'
      },
      {
        key: 'totalDiscounted',
        label: 'Total descontado'
      },
      {
        key: 'enabled',
        label: 'Ativo'
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
